import Vue from 'vue'
import axios from '@/config/axios'
import each from 'lodash/each'
import dotObject from 'dot-object';
import {getField, updateField} from "vuex-map-fields";
import {SET_STATE} from "../mutations";
import {STATUSES} from "@/components/statuses";
import {PARSE_CONFIG, BLOCKS_CONFIG} from "@/storage/config/profileConfig";
import Helpers from "@/modules/Helpers";
import Raven from 'raven-js'

const INIT = 'INIT';
const NO_STATUSES_FIELDS = ['isInited', 'middleNameUpsent'];


const profile = {
    namespaced: true,
    state: {
        isInited: false,
        phone: '',
        email: '',


        lastName: '',
        lastNameExternalStatus: STATUSES.EMPTY,
        firstName: '',
        firstNameExternalStatus: STATUSES.EMPTY,
        middleNameUpsent: false,
        secondName: '',
        secondNameExternalStatus: STATUSES.EMPTY,
        iin: '',
        iinExternalStatus: STATUSES.EMPTY,
        birthDate: '',
        birthDateExternalStatus: STATUSES.EMPTY,
        sex: '',
        sexExternalStatus: STATUSES.EMPTY,
        document: '',
        documentExternalStatus: STATUSES.EMPTY,
        citizenship: '',
        citizenshipExternalStatus: STATUSES.EMPTY,
        documentNumber: '',
        documentNumberExternalStatus: STATUSES.EMPTY,
        dateOfIssue: '',
        dateOfIssueExternalStatus: STATUSES.EMPTY,
        dateOfDuration: '',
        dateOfDurationExternalStatus: STATUSES.EMPTY,


        registrationState: '',
        registrationStateExternalStatus: STATUSES.EMPTY,
        registrationDistrict: '',
        registrationDistrictExternalStatus: STATUSES.EMPTY,
        registrationCity: '',
        registrationCityExternalStatus: STATUSES.EMPTY,
        registrationStreet: '',
        registrationStreetExternalStatus: STATUSES.EMPTY,
        registrationHouse: '',
        registrationHouseExternalStatus: STATUSES.EMPTY,
        registrationApartment: '',
        registrationApartmentExternalStatus: STATUSES.EMPTY,
        registrationHomePhone: '',
        registrationHomePhoneExternalStatus: STATUSES.EMPTY,

        homeState: '',
        homeStateExternalStatus: STATUSES.EMPTY,
        homeDistrict: '',
        homeDistrictExternalStatus: STATUSES.EMPTY,
        homeCity: '',
        homeCityExternalStatus: STATUSES.EMPTY,
        homeStreet: '',
        homeStreetExternalStatus: STATUSES.EMPTY,
        homeHouse: '',
        homeHouseExternalStatus: STATUSES.EMPTY,
        homeApartment: '',
        homeApartmentExternalStatus: STATUSES.EMPTY,
        liveWhereRegistred: '',
        liveWhereRegistredExternalStatus: STATUSES.EMPTY,

        workType: '',
        workTypeExternalStatus: STATUSES.EMPTY,
        workPlace: '',
        workPlaceExternalStatus: STATUSES.EMPTY,
        workPhone: '',
        workPhoneExternalStatus: STATUSES.EMPTY,
        workAdditionalPhone: '',
        workAdditionalPhoneExternalStatus: STATUSES.EMPTY,
        additionalIncome: '',
        additionalIncomeExternalStatus: STATUSES.EMPTY,


        firstRelativePhone: '',
        firstRelativePhoneExternalStatus: STATUSES.EMPTY,
        firstRelativeFIO: '',
        firstRelativeFIOExternalStatus: STATUSES.EMPTY,
        firstRelativeAccountedFor: '',
        firstRelativeAccountedForExternalStatus: STATUSES.EMPTY,

        secondRelativePhone: '',
        secondRelativePhoneExternalStatus: STATUSES.EMPTY,
        secondRelativeFIO: '',
        secondRelativeFIOExternalStatus: STATUSES.EMPTY,
        secondRelativeAccountedFor: '',
        secondRelativeAccountedForExternalStatus: STATUSES.EMPTY,
    },
    mutations: {
        profileInit(state){
            state.isInited = true;
        },
        [SET_STATE](state, payload) {
            state[payload.fieldName] = payload.value;
            each(BLOCKS_CONFIG, function (item, key) {
                if (item.fields.indexOf(payload.fieldName) > -1) {
                    if (payload.fieldName === 'secondName') {
                        if (payload.value === '') {
                            if (payload.middleNameUpsent) {
                                item.filledCount += 1;
                            }
                        } else {
                            item.filledCount += 1;
                        }
                    } else {
                        item.filledCount += 1;
                    }
                }
                if (item.fields.length === item.filledCount) {
                    item.confirmed = true;
                    each(item.fields, function (cItem, cKey) {
                        state[cItem + 'ExternalStatus'] = STATUSES.COMPLETE;
                    })
                }
            });
        },
        updateField
    },
    actions: {

        [INIT](){
            let _this = this;
            if( !this.state.isInited ){
                axios.get('/json/profile').then(
                    response => {
                        if(response.data.code === 0){
                            Raven.setUserContext({
                               email: response.data.data.email,
                               phone: response.data.data.mobilePhone,
                               id: response.data.data.id
                            });

                            _this.commit('profile/profileInit');

                            _this.commit('profile/SET_STATE',{fieldName: 'email', value: response.data.data.email });
                            _this.commit('profile/SET_STATE',{fieldName: 'phone', value: response.data.data.mobilePhone});

                            let dotProfile = dotObject.dot(response.data.data);
                            each(PARSE_CONFIG, function (item, key) {
                                // Составное поле типа дата
                               if(item && item.toLowerCase().indexOf('date') > -1){
                                    _this.commit('profile/SET_STATE',{fieldName: key, value: Helpers.parseDateFromJAVA(dotProfile, item)});
                                    return;
                               }
                               // Поле "Отчество"
                               if(key === 'secondName'){
                                   if(dotProfile[item] === '' || !dotProfile[item]){
                                       _this.commit('profile/SET_STATE', {
                                           fieldName: key,
                                           value: 'Нет отчества',
                                           middleNameUpsent: true
                                       });
                                       return;
                                   }
                               }

                               if(dotProfile[item] && dotProfile[item] !== ''){
                                   _this.commit('profile/SET_STATE', {fieldName: key, value: dotProfile[item]});
                               }
                            });
                        }else if(response.data.code === 500){

                        }
                    },
                    response => {}
                ).catch(Error => {

                })
            }
        }
    },
    getters: {
        getField,
        isInited: (state) => {
            return state.isInited;
        }
    }
};

export default profile;